module.exports = __webpack_public_path__ + "media/components/assets/upcycling_02-a1e972b2e148e2e2ec3649a809c51a66.jpg";